import React, { useState } from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { useLocation, useNavigate, Link } from 'react-router-dom';

export default function WhatsAppContact() {
  const location = useLocation();
    const navigate = useNavigate();
  const carInfoFromHome = location.state?.carInfo || {};
  
  const [formData, setFormData] = useState({
    make: carInfoFromHome.make || '',
    model: carInfoFromHome.model || '',
    year: carInfoFromHome.year || '',
    mileage: carInfoFromHome.mileage || '',
    bodyType: carInfoFromHome.bodyType || '',
    fuelType: carInfoFromHome.fuelType || '',
    power: carInfoFromHome.power || '',
    variant: carInfoFromHome.variant || '',
    transmission: carInfoFromHome.transmission || '',
    doors: carInfoFromHome.doors || '',
    type: carInfoFromHome.type || '',
    expectedPrice: carInfoFromHome.expectedPrice || '',
        offerPrice: carInfoFromHome.offerPrice || '',
    additionalInfo: '',
    name: '',
    phone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create WhatsApp message with car details
    const message = encodeURIComponent(
      `Fahrzeuganfrage:\n\n` +
      `Marke: ${formData.make}\n` +
      `Modell: ${formData.model}\n` +
      `Baujahr: ${formData.year}\n` +
      `Kilometerstand: ${formData.mileage} km\n` +
      `Bauform: ${formData.bodyType}\n` +
      `Kraftstofftyp: ${formData.fuelType}\n` +
      `PS / kW: ${formData.power}\n` +
      `Variant: ${formData.variant}\n` +
      `Getriebeart: ${formData.transmission}\n` +
      `Türen: ${formData.doors}\n` +
      `Modelltyp: ${formData.type}\n` +
            (formData.offerPrice ? `Angebot: €${formData.offerPrice}\n` : '') +
      (formData.expectedPrice ? `Wunschpreis: €${formData.expectedPrice}\n` : '') +
      `Zusätzliche Informationen: ${formData.additionalInfo}\n` +
      `Name: ${formData.name}\n` +
      `Telefon: ${formData.phone}`
    );
    
        // WhatsApp (wa.me) expects a digits-only number (no leading '+')
        const phoneNumber = '4915730710451';

        // Open WhatsApp with pre-filled message
        const openedWindow = window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');

        // "Successful" here means: browser didn't block opening a new tab/window.
        if (openedWindow) {
            navigate('/whatsapp-thank-you');
        } else {
            alert('Bitte erlauben Sie Pop-ups, um WhatsApp zu öffnen.');
        }
  };

return (
    <Container className="py-5">
        <Card className="shadow">
            <Card.Header as="h2" className="text-center">Anfrage per WhatsApp</Card.Header>
            <Card.Body>
                {formData.offerPrice ? (
                    <p className="text-center text-muted mb-3">
                        Berechnetes Angebot: <strong>€{formData.offerPrice}</strong>
                    </p>
                ) : null}
                <Form onSubmit={handleSubmit}>
                    <h4 className="mb-3">Fahrzeugdetails</h4>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Marke</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="make" 
                                    value={formData.make} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Modell</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="model" 
                                    value={formData.model} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Baujahr</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="year" 
                                    value={formData.year} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Kilometerstand (km)</Form.Label>
                                <Form.Control 
                                    type="number" 
                                    name="mileage" 
                                    value={formData.mileage} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Bauform</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="bodyType" 
                                    value={formData.bodyType} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Kraftstofftyp</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="fuelType" 
                                    value={formData.fuelType} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Leistung (PS/ kW) </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="power" 
                                    value={formData.power} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Variante</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="variant" 
                                    value={formData.variant} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Getriebeart</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="transmission" 
                                    value={formData.transmission} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Anzahl Türen</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="doors" 
                                    value={formData.doors} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Modelltyp</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="type" 
                                    value={formData.type} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Wunschpreis</Form.Label>
                                <Form.Control 
                                    type="number" 
                                    name="expectedPrice" 
                                    value={formData.expectedPrice} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <h4 className="mb-3 mt-4">Ihre Kontaktdaten</h4>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Ihr Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="name" 
                                    value={formData.name} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Ihre Telefonnummer</Form.Label>
                                <Form.Control 
                                    type="tel" 
                                    name="phone" 
                                    value={formData.phone} 
                                    onChange={handleChange} 
                                    required 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Zusätzliche Informationen</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3} 
                            name="additionalInfo" 
                            value={formData.additionalInfo} 
                            onChange={handleChange} 
                        />
                    </Form.Group>
                    
                    <div className="d-grid gap-2">
                        <Button variant="success" type="submit" size="lg">
                            Über WhatsApp senden
                        </Button>
                    </div>

                    <div className="text-center mt-3">
                        <small className="text-muted">
                            Lieber per E-Mail?{' '}
                            <Link to="/email-contact" state={{ carInfo: { ...formData } }}>
                                Hier per E-Mail anfragen
                            </Link>
                        </small>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    </Container>
);
}
